var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultPic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8651",
    "data-name": "Group 8651",
    transform: "translate(1 -23)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "nadine-burzler-FsXq3xu72bs-unsplash-2",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(-1 23)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M20.716,3.573H6.215A3.457,3.457,0,0,1,2.762.12V-8.857H2.072A2.072,2.072,0,0,0,0-6.785V4.263A2.072,2.072,0,0,0,2.072,6.335H18.644a2.072,2.072,0,0,0,2.072-2.072ZM24.859.12V-10.928A2.072,2.072,0,0,0,22.788-13H6.215a2.072,2.072,0,0,0-2.072,2.072V.12A2.072,2.072,0,0,0,6.215,2.192H22.788A2.072,2.072,0,0,0,24.859.12ZM11.049-8.857A2.072,2.072,0,0,1,8.977-6.785,2.072,2.072,0,0,1,6.905-8.857a2.072,2.072,0,0,1,2.072-2.072A2.072,2.072,0,0,1,11.049-8.857ZM6.905-2.642l2.4-2.4a.518.518,0,0,1,.732,0l1.705,1.705,5.849-5.849a.518.518,0,0,1,.732,0L22.1-5.4V-.57H6.905Z",
    transform: "translate(25.57 64.332)",
    fill: "#b7b7b7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPic);
export default __webpack_public_path__ + "static/media/defaultPic.4740df8f107bf63f19a4f751a92d165e.svg";
export { ForwardRef as ReactComponent };